import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    // domApiPath: window.env.DOMINATOR_API_URL,
    // domImagePath: window.env.DOMINATOR_IMAGE_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '/pages': {
                params: { filter: 'parent_id$id' },
            },
            // '/panels': {
            //    params: { filter: 'local_page_id:$null' },
            // },
            // '/categories': {
            //     params: { filter: 'parent_id$id' },
            // },
            '/products': {
                params: { filter: 'append:category_list' },
            },
            // '/orders': {
            //     params: { sort: 'order_date:desc' }
            // },
            '/customers': {
                // params: { filter: 'approval_status:Approved' }
            },
            '/suppliers': {
                // params: { filter: 'approval_status:Approved' }
            },
            '/terms': {
                // params: { filter: 'approval_status:Approved' }
            },
            '/logins': {
                // params: { filter: 'approval_status:Approved' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/base.js